// extracted by mini-css-extract-plugin
export default {"textHeader":"Wqloa2R6"};